var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-64", attrs: { "data-grm-comp": "RoomTestbankViewInfo" } },
    [
      _c("div", { staticClass: "room-exam-view-info" }, [
        _c(
          "div",
          { staticClass: "bg-indigo-50 flex justify-center items-center" },
          [_c("RoomExamTimer", { staticClass: "w-full" })],
          1
        ),
        _c("div", { staticClass: "room-exam-view-info-body" }, [
          _c(
            "div",
            { staticClass: "room-exam-view-info-contents" },
            [
              _c(
                "div",
                { staticClass: "room-exam-view-info-contents-header" },
                [
                  _c(
                    "GrmCheckbox",
                    {
                      attrs: { id: "showAnswer" },
                      model: {
                        value: _vm._showAnswer,
                        callback: function ($$v) {
                          _vm._showAnswer = $$v
                        },
                        expression: "_showAnswer",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("testBank.info.showAnswer")))]
                  ),
                ],
                1
              ),
              _c("perfect-scrollbar", { staticClass: "min-h-0 flex-1" }, [
                _c(
                  "div",
                  { staticClass: "room-exam-view-info-contents-body" },
                  [
                    _c(
                      "RoomExamInfoForm",
                      { attrs: { users: _vm.progressUsers } },
                      [_vm._v(_vm._s(_vm.$t("testBank.info.ongoing")))]
                    ),
                    _c(
                      "RoomExamInfoForm",
                      { attrs: { users: _vm.completedUsers } },
                      [_vm._v(_vm._s(_vm.$t("testBank.info.submitComplete")))]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "room-exam-view-info-footer" }, [
          _c("div", { staticClass: "room-exam-view-button-wrapper" }, [
            _c(
              "button",
              {
                staticClass: "room-exam-view-button finish",
                on: { click: _vm.onClickFinish },
              },
              [_vm._v(_vm._s(_vm.$t("common.quit")))]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }